module.exports = __webpack_public_path__ + "img/close.6d48dffd.svg";